export const isValidJSON = (str: string) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

export const toNum = (v: any) => parseFloat(String(v ?? 0)) || 0;
